import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { BitmapText } from "pixi.js";
import { getSpineSymbol, getSymbol } from "../../config/getSymbol";
import { isSuperQuickBtnOnGlobal, RespinIndex } from "../../config/GlobalVariableConfig";
import { REEL_NUMBERS, SYMBOLS_PER_REEL } from "../../config/reelConfig";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { DisplayComponent } from "../../core/displays/DisplayComponent";
import { ReelObject, SymbolObject } from "../../core/reels/ReelInit";
import { Reels } from "../../core/reels/Reels";
import { wait } from "../../core/utils";
import { SequentialTask } from "../../core/utils/SequentialTask";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";
import { GameConstants } from "../../GameConstants/GameConstants";
import { ITransCoin } from "../../server/getServerResposesFun";
import { FeaturePotComponent } from "../featurePot/FeaturePotComponent";
import { ReelComponent } from "../reels/ReelsComponent";
import { TrailsComponent } from "../trail/TrailsComponent";

export class TransCoinsComponent extends AbstractDisplayComponent {
    private transcoins: ITransCoin[];

    public startTransformFeature(transformCoins: ITransCoin[], callback?: () => void): Promise<any> {
        this.transcoins = transformCoins;

        if (!this.transcoins || this.transcoins.length === 0) {
            console.warn("No featureData found at index", RespinIndex.value);
            callback?.();
            return Promise.resolve();
        }

        let seq = new SequentialTask([
            () => {
                const reels = DisplayComponent.get(ReelComponent).getInstance();
                this.markAllReelSymbols(reels, "0x555555");
                this.markWinSymbols(reels, "0xffffff");
            },
            () => this.transformSymbols(),
            () => {
                const reels = DisplayComponent.get(ReelComponent).getInstance();
                this.markAllReelSymbols(reels, "0xffffff");
            },
            //() => this.showMeterHighlight(),
            () => wait(500),
            () => {
                callback?.();
                return Promise.resolve();
            }
        ]);
        return seq.execute();
    }

    // public startCollectFeature(respinIndex: number, callback?: () => void): Promise<any> {
    //     const data: RespinObject = spinData.respins[respinIndex];
    //     this.transcoins = data?.transcoins;

    //     if (!this.transcoins) {
    //         console.warn("No featureData found at index", RespinIndex.value);
    //         callback?.();
    //         return Promise.resolve();
    //     }

    //     let seq = new SequentialTask([
    //         () => this.animateReelTriumpSymbols(),
    //         () => this.updateMeterText(),
    //         () => wait(500),
    //         () => {
    //             callback?.();
    //             return Promise.resolve();
    //         }
    //     ]);
    //     return seq.execute();
    // }
    public async transformSymbol(transformCoins: ITransCoin[], reelInd: number, posInd: number, callback?: () => void): Promise<void> {
        this.transcoins = transformCoins;
        let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        //let taskArr: Promise<void>[] = [];
        //let transWinPos = this.transcoins;
        const reels = DisplayComponent.get(ReelComponent).getInstance();
        //this.markAllReelSymbols(reels, "0x555555");
        //this.markWinSymbols(reels, "0xffffff");
        //const colourTrail = DisplayComponent.get(TrailsComponent).getInstance().greenTrail;
        //trail?.skeleton.setToSetupPose();
        // for (let i = 0; i < transWinPos.length; i++) {
        //     if (i != 0)
        //         await isSuperQuickBtnOnGlobal ? wait(10) : wait(100);
        //taskArr.push(new Promise<void>(async (resolve) => {
        const coin: ITransCoin = this.transcoins.find(
            item => item.reelNum === reelInd && item.posNum === posInd
        );
        const posNum = coin.posNum;
        const reelNum = coin.reelNum;
        const sym = reels.reelSymbols[reelNum][posNum];
        const trailIndex = reelNum * SYMBOLS_PER_REEL + posNum;
        const trailNumber = trailIndex + 1;
        const colourTrail = this.getColourTrail(reels.allReelArray[reelNum], posNum);
        const colourTrailAnimPrefix = this.getTrailAnimPrefix(reels.allReelArray[reelNum], posNum);
        colourTrail.state.timeScale = timeScale;
        sym.tint = "0xffffff";
        //colourTrail?.skeleton.setToSetupPose();
        console.log("Symbol Id ===> ");
        console.log(reels.allReelArray[reelNum].symbols[posNum].id);
        colourTrail?.skeleton.data.animations.forEach((anim) => {
            console.log(anim);
        });
        sound.play(SoundConstants.GOD_SYMBOL_FIRING, { volume: 0.4 });
        colourTrail?.state.setAnimation(trailIndex, colourTrailAnimPrefix + trailNumber, false);
        sym.state.timeScale = timeScale;
        this.getColourFeaturePot(this.getFeatureBallId(reels.allReelArray[reelNum], posNum))?.state.setAnimation(0, "collect", false);
        //if (!isSuperQuickBtnOnGlobal)
        //  await this.playAnimation(sym, "win", false);
        //reelSpinEmitter.emit('potCollect', this.getFeatureBallId(reels.allReelArray[reelNum], posNum));
        this.swapSymbol(reels.allReelArray[reelNum], posNum, true, GameConstants.COIN_SYMBOL_ID);
        const newCoinSym = getSpineSymbol(GameConstants.COIN_SYMBOL_ID);
        newCoinSym.skeleton.setToSetupPose();
        const multText = new BitmapText({
            text: "",
            style: {
                fontFamily: '3God_coin',
                trim: true,
                fontSize: 60
            }
        });
        multText.label = "collect_meter_text";
        multText.anchor = 0.5;
        multText.text = coin.value + "x";
        newCoinSym.addSlotObject("multiplier", multText);
        newCoinSym.state.timeScale = timeScale;
	sound.play(SoundConstants.GOD_SYMBOL_FLIP, { volume: 0.5 });
        // Play reveal animation on original symbol with event listener
        return new Promise<void>((resolve) => {
            let resolved = false;
            let symbolSwapped = false;

            const revealListener = {
                event: (_entry: any, event: any) => {
                    if (!symbolSwapped && event?.data?.name === "gold_coin_start") {
                        symbolSwapped = true;
                        console.log("Gold coin start event triggered, swapping symbol now");

                        // Add new coin symbol WITHOUT removing/destroying old sym yet
                        reels.reelSymbolContainers[reelNum][posNum].addChild(newCoinSym);
                        reels.reelSymbols[reelNum][posNum] = newCoinSym;

                        // Play reveal on the new coin symbol
                        newCoinSym.state.setAnimation(0, "reveal", false);
                    }
                },
                complete: () => {
                    // This fires when sym's "reveal" animation completes
                    if (resolved) return;
                    resolved = true;
                    sym.state.clearListeners();

                    // Now it's safe to remove and destroy the old symbol
                    reels.reelSymbolContainers[reelNum][posNum].removeChild(sym);
                    sym.destroy();

                    newCoinSym.state.clearListeners();
                    colourTrail?.skeleton.setToSetupPose();
                    callback?.();
                    resolve();
                }
            };
            sym.state.setAnimation(0, "reveal", false).listener = revealListener;
        });
        //}));
        //}
        // if (taskArr.length === 0) return Promise.resolve();
        // await Promise.all(taskArr);
    }

    private async transformSymbols(): Promise<void> {
        let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        let taskArr: Promise<void>[] = [];
        let transWinPos = this.transcoins;
        const reels = DisplayComponent.get(ReelComponent).getInstance();
        //this.markAllReelSymbols(reels, "0x555555");
        //this.markWinSymbols(reels, "0xffffff");
        //const colourTrail = DisplayComponent.get(TrailsComponent).getInstance().greenTrail;
        //trail?.skeleton.setToSetupPose();
        for (let i = 0; i < transWinPos.length; i++) {
            if (i != 0)
                await wait(100);
            taskArr.push(new Promise<void>(async (resolve) => {
                const posNum = transWinPos[i].posNum;
                const reelNum = transWinPos[i].reelNum;
                const sym = reels.reelSymbols[reelNum][posNum];
                const trailIndex = reelNum * SYMBOLS_PER_REEL + posNum;
                const trailNumber = trailIndex + 1;
                const colourTrail = this.getColourTrail(reels.allReelArray[reelNum], posNum);
                const colourTrailAnimPrefix = this.getTrailAnimPrefix(reels.allReelArray[reelNum], posNum);
                colourTrail.state.timeScale = timeScale;
                sym.tint = "0xffffff";
                //colourTrail?.skeleton.setToSetupPose();
                console.log("Symbol Id ===> ");
                console.log(reels.allReelArray[reelNum].symbols[posNum].id);
                colourTrail?.skeleton.data.animations.forEach((anim) => {
                    console.log(anim);
                });
                sound.play(SoundConstants.GOD_SYMBOL_FIRING, { volume: 0.4 });
                colourTrail?.state.setAnimation(trailIndex, colourTrailAnimPrefix + trailNumber, false);
                sym.state.timeScale = timeScale;
                this.getColourFeaturePot(this.getFeatureBallId(reels.allReelArray[reelNum], posNum))?.state.setAnimation(0, "collect", false);
                await this.playAnimation(sym, "win", false);
                //reelSpinEmitter.emit('potCollect', this.getFeatureBallId(reels.allReelArray[reelNum], posNum));
                this.swapSymbol(reels.allReelArray[reelNum], posNum, true, GameConstants.COIN_SYMBOL_ID);
                const newCoinSym = getSpineSymbol(GameConstants.COIN_SYMBOL_ID);
                newCoinSym.skeleton.setToSetupPose();
                const multText = new BitmapText({
                    text: "",
                    style: {
                        fontFamily: '3God_coin',
                        trim: true,
                        fontSize: 60
                    }
                });
                multText.label = "collect_meter_text";
                multText.anchor = 0.5;
                multText.text = transWinPos[i].value + "x";
                newCoinSym.addSlotObject("multiplier", multText);
                newCoinSym.state.timeScale = timeScale;
                sound.play(SoundConstants.GOD_SYMBOL_FLIP, { volume: 0.5 });
                newCoinSym.state.setAnimation(0, "reveal", false);
                reels.reelSymbolContainers[reelNum][posNum].addChild(newCoinSym);
                await this.playAnimation(sym, "reveal", false);
                reels.reelSymbolContainers[reelNum][posNum].removeChild(sym);
                sym.destroy();
                reels.reelSymbols[reelNum][posNum] = newCoinSym;
                colourTrail?.skeleton.setToSetupPose();
                resolve();
            }));
        }
        if (taskArr.length === 0) return Promise.resolve();
        await Promise.all(taskArr);
    }

    private markWinSymbols(reels: Reels, tint: string): void {
        for (let i = 0; i < this.transcoins.length; i++) {
            const posNum = this.transcoins[i].posNum;
            const reelNum = this.transcoins[i].reelNum;
            const symbol = reels.reelSymbols[reelNum][posNum]
            symbol.tint = tint;
        }
    }

    private markAllReelSymbols(reels: Reels, tint: string): void {
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                let symbol = reels.reelSymbols[reelNum][posNum]
                symbol.tint = tint;
            }
        }
    }

    private getFeatureBallId(reelObj: ReelObject, posNum: number): number {
        const symbol = reelObj.symbols[posNum];
        switch (symbol.id) {
            case 13:
                return 2;
            case 14:
                return 3;
            case 15:
                return 1;
            default:
                return 1;
        }
    }

    private getColourTrail(reelObj: ReelObject, posNum: number): Spine | null {
        const symbol = reelObj.symbols[posNum];
        switch (symbol.id) {
            case 13:
                return DisplayComponent.get(TrailsComponent).getInstance().greenTrail;;
            case 14:
                return DisplayComponent.get(TrailsComponent).getInstance().pinkTrail;
            case 15:
                return DisplayComponent.get(TrailsComponent).getInstance().blueTrail;
            default:
                return null;
        }
    }

    private getColourFeaturePot(potNum: number): Spine | null {
        switch (potNum) {
            case 1:
                return DisplayComponent.get(FeaturePotComponent).getInstance().blueFeatureIndicator;
            case 2:
                return DisplayComponent.get(FeaturePotComponent).getInstance().greenFeatureIndicator;
            case 3:
                return DisplayComponent.get(FeaturePotComponent).getInstance().redFeatureIndicator;
            default:
                return null;
        }
    }

    private getTrailAnimPrefix(reelObj: ReelObject, posNum: number): string | null {
        const symbol = reelObj.symbols[posNum];
        //trail animation names are wring in the assets
        switch (symbol.id) {
            case 13:
                return "doubler_trail_";
            case 14:
                return "adder_trail_";
            case 15:
                return "collecter_trail_";
            default:
                return "adder_trail_";
        }
    }

    private swapSymbol(reelObj: ReelObject, symbolId: number, visibility: boolean = true, newSymbolId: number = 22): SymbolObject {
        const symbol = reelObj.symbols[symbolId];
        visibility;
        if (symbol) {
            // symbol.symbol.destroy();
            const newSym = getSymbol(newSymbolId);
            // symbol.view.addChildAt(newSym, 0);
            symbol.id = newSymbolId;
            symbol.symbol.texture = newSym;
            // symbol.view.visible = visibility;
            // symbol.view.tint = 0xffffff;
            // symbol.view.alpha = 1;
            symbol.symbolIndex = symbolId;

        }
        return symbol;
    }

    private playAnimation(sym: Spine, animationName: string, loop: boolean = false): Promise<void> {
        return new Promise((resolve) => {
            let resolved = false;
            let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            const listener = {
                complete: () => {
                    if (resolved) return;
                    resolved = true;
                    sym.state.removeListener(listener);
                    resolve();
                }
            };
            sym.state.addListener(listener);
            sym.state.timeScale = timeScale;
            sym.state.setAnimation(0, animationName, loop);
        });
    }

    // //@ts-ignore
    // private showMeterHighlight() {
    //     // let triumpWin = this.transcoins.triumpWinData?.winAmount;
    //     // if (triumpWin > 0) {
    //     //     let jp = getJackpotEntryByValue(triumpWin);
    //     //     if (jp) {
    //     //         return new Promise<void>((resolve) => {
    //     //             DisplayComponent.get(MeterComponent).highlight(jp.index, resolve);
    //     //         });
    //     //     }
    //     // }

    //     return Promise.resolve();
    // }

    // private animateReelTriumpSymbols() {
    //     for (let i = 0; i < REEL_NUMBERS; i++) {
    //         for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
    //             const sym = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[i][j];
    //             const reelObj = DisplayComponent.get(ReelComponent).getInstance().allReelArray[i];
    //             const symbolId = reelObj.symbols[j].id;
    //             if (symbolId === GameConstants.SPECIAL_SYMBOL_ID) {
    //                 sym.state.setAnimation(0, "win", false);
    //                 DisplayComponent.get(TrailsComponent).triggerTrail(sym, DisplayComponent.get(MeterComponent).getCurrentActiveMeter(), DisplayComponent.get(MeterComponent).getActiveMeterId() - 1, () => {
    //                     //sym.state.setAnimation(0, "idle", true);
    //                 });
    //             }
    //         }
    //     }
    // }

    // private updateMeterText() {
    //     // let triumpCollected = this.transcoins.triumpCollectData?.collected;
    //     // if (triumpCollected > 0) {
    //     //     DisplayComponent.get(MeterComponent).updateMeterText(triumpCollected);
    //     // }
    //     return Promise.resolve();
    // }

    public getInstance(): any {
        return null;
    }
}
